import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/public/app/e-commerce-tour/[...slug]/e-commerce-tour-page-client.tsx");
